export default __webpack_public_path__ + "static/media/torus.602b6ee1.obj";